import type {PartSelectableObject} from "./partSelOb";
import {HandleContainer} from "./interactionHandleBaseClass";
import {HandleShaderCreator} from "./shader/OwayoShader";
import {THREE} from "./resource/BVH.js";


export class Handles {
    private readonly parentPartSelob:PartSelectableObject;
    private readonly insertTarget;
    private readonly handles:HandleContainer;
    private visible =false;

    constructor(parent:PartSelectableObject, insertTarget) {
        this.parentPartSelob = parent;
        this.insertTarget = insertTarget;
        this.handles = new HandleContainer(this.parentPartSelob);
    }

    public place(handlesToShow, extremesWithTranslation) {

        let index,
            handleName,
            newShaderNeeded = false,
            uniforms;

        if (this.visible === true) {
            uniforms = this.parentPartSelob.getParent().handleShader.uniforms;
        } else {
            uniforms = null;
        }

        this.handles.pinHandle.status = (this.parentPartSelob.isPinned === true ? "pinned" : "notPinned");
        if (uniforms !== null) {
            index = this.insertTarget.indexOf(this.handles.pinHandle);
            uniforms.handleIconIndex.value[index] = this.handles.pinHandle.iconIndizes[this.handles.pinHandle.status];
        }

        if (this.visible === false) {
            newShaderNeeded = true;
        }
        for (handleName in this.handles) {
            this.handles[handleName].shouldBeVisible = handlesToShow[handleName];
            this.handles[handleName].setTranslationFromExtremes(extremesWithTranslation);
            newShaderNeeded = this.handles[handleName].setVisibilityAndAddToTarget(this.insertTarget) || newShaderNeeded;  //wenn einmal true bleibts true
        }
        if (!newShaderNeeded) { //Handles sind bereits gezeichnet und im Shader
            this.setTranslationOnHandles(uniforms);
        } else {
            this.visible = true;
            this.parentPartSelob.getParent().handleShader = HandleShaderCreator.createHandleShader(this.parentPartSelob.getParent());
        }

    }

    private setTranslationOnHandles(uniforms) {
        let handleName, index;
        for (handleName in this.handles) {
            index = this.insertTarget.indexOf(this.handles[handleName]);
            uniforms.handleTranslation.value[index]
                = new THREE.Vector2(this.handles[handleName].translation.x, this.handles[handleName].translation.y);
        }
    }

    private setAllHandleVisibilityFlagsToFalse() {
        let handleName;
        for (handleName in this.handles) {
            this.handles[handleName].isVisible = false;
        }
    }

    /**
     * Löscht die Handles aus dem selectableObject Array und schaltet die Visible Flags auf false;
     * @param {boolean}    [createShader = true]    Flag, ob ein neuer Shader erstellt werden soll
     */
    hide(createShader=true) {
        this.setAllHandleVisibilityFlagsToFalse();

        const handleFor = this.handles.pinHandle.handleFor;

        for (let i = this.insertTarget.length - 1; i > -1; i--) {
            if (this.insertTarget[i].handleFor === handleFor) {
                this.handles[this.insertTarget[i].id].isVisible = false;
                this.insertTarget.splice(i, 1);
            }
        }
        this.visible = false;
        if (createShader) {
            this.parentPartSelob.getParent().handleShader = HandleShaderCreator.createHandleShader(this.parentPartSelob.getParent());
        }
    }
}
